export default {
  data: [
    { name: "rissas", id: 1463 },
    { name: "graveyron", id: 815 },
    { name: "bergies", id: 1460 },
    { name: "rustrel", id: 601 },
    { name: "banon", id: 157 },
    { name: "saint_amand", id: 1336 },
    { name: "ventoux-graviere", id: 1484 },
    { name: "saint-jean", id: 1552 },
    { name: "Soubeyrand", id: 1417 },
    { name: "Trappe-Mevouillon", id: 1498 },
    { name: "Le Seigneur", id: 1657 },
  ],
};
